import { createModel } from "hox";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "../../../utils/constants";
import { TablePaginationConfig } from "antd/es/table/interface";
import React, { useState } from "react"
import { filterArrId, Optios, transPgToPagination, findOption, forFind } from "../../../utils/utils"
import { IPgProps, ISearchPage } from "../../../types/FmsTypes";
import { PaginationProps } from "antd/es/pagination";
import { globalPrompt } from "../../../components2/YhMessage"
import { customerService } from "./customerService"
import useMdmModel from "../../../model/mdmModel"
import { ICustomerSearch, ICustomerParams, ICustomerDetail, ICustomerInsert, ICustomerUpdata, ICustomerDisable, ShareShop, ShareUser } from "./customerTypes"
import { useGlobalModel } from "../../../model/globalModel"

export const useCustomerModel = createModel(function () {
    const { user } = useGlobalModel()
    const { mdmOrgan, userAll, shop } = useMdmModel();
    const initSearchParams: ICustomerParams = {}
    const initDataSource: ICustomerDetail[] = []
    const initAddParam: ICustomerInsert = { enable: true, level: 1, branch: "main" }
    const initPage: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    //查询条件
    const [searchParam, setSearchParam] = useState<ICustomerParams>(initSearchParams)
    //列表数据
    const [dataSource, setDataSource] = useState<ICustomerDetail[]>(initDataSource);
    //分页参数
    const [page, setPage] = useState<TablePaginationConfig>(initPage);
    ////表格选中行的数据
    const [selectedRow, setSelectedRow] = useState<ICustomerDetail[]>([]);
    //新增参数
    const [addParam, setAddParam] = useState<ICustomerInsert>(initAddParam);
    //银行类型
    const [bankList, setBankList] = useState<Optios[]>([])
    //客户类型
    const [customerTypeList, setCustomerTypeList] = useState<Optios[]>([])
    //门店共享
    const [shopModel, setShopModel] = useState<boolean>(false)
    const [userModel, setUserModel] = useState<boolean>(false)


    const upDataSearchParam = (upDataParam: ICustomerParams) => {
        let newUpDataParam = upDataParam
        setSearchParam({ ...searchParam, ...newUpDataParam })
    }
    const resetSearchParam = async () => {
        await setSearchParam(initSearchParams)
        const resetPage = { pageSize: 15, pageNum: 1 }
        await loadData(resetPage, initSearchParams)
    }
    const loadData = async (pages?: ISearchPage, data?: ICustomerParams) => {
        const searchParams = data ?? searchParam
        const params = {
            ...searchParams,
            page: {
                pageSize: pages?.pageSize ?? page.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: pages?.pageNum ?? page.current ?? DEFAULT_FIRST_PAGE_NUM
            }
        }
        const { retData } = await customerService.page(params)
        const { records, ...pg } = retData
        setPage(transPgToPagination(pg));
        setDataSource(records)
    }
    //用于门店共享，在有条件时， 选中复合条件的所有数据
    const checkLoadData = async () => {
        const params = {
            ...searchParam,
            page: {
                pageSize: 999999,
                pageNum: 1
            }
        };
        const { retData: { records, ...pg } } = await customerService.page(params);
        records && setSelectedRow(records);
        return records;
    }

    const updataAddParam = (updateParam: ICustomerInsert) => {
        let newUpdateParam = updateParam
        if ("categoryCode" in updateParam) {
            let findItem = findOption(updateParam.categoryCode as string, customerTypeList)
            newUpdateParam = { ...updateParam, categoryName: findItem?.label }
        }
        if ("orgCode" in updateParam) {
            let findItem = forFind(mdmOrgan, updateParam.orgCode as string, "code")
            newUpdateParam = { ...updateParam, orgName: findItem?.name as string }
        }
        setAddParam({ ...addParam, ...newUpdateParam })
    }
    const updataEditParam = (updateParam: ICustomerUpdata) => {
        let newUpdateParam = updateParam
        if ("categoryCode" in updateParam) {
            let findItem = findOption(updateParam.categoryCode as string, customerTypeList)
            newUpdateParam = { ...updateParam, categoryName: findItem?.label }
        }
        if ("orgCode" in updateParam) {
            let findItem = forFind(mdmOrgan, updateParam.orgCode as string, "code")
            newUpdateParam = { ...updateParam, orgName: findItem?.name as string }
        }
        setSelectedRow([{ ...selectedRow[0], ...updateParam }])
    }
    const insertDetail = async (params: ICustomerInsert) => {
        const param = {
            ...addParam,
            ...params,
            sourceApp: "main",
            enable: params.enable ? 1 : 0,
            createUser: user.createUser
        }
        const { retData, retMsg } = await customerService.insert(param)
        globalPrompt("message", { type: "success", text: retMsg })
        return retData
    }
    const updataDetail = async (params: ICustomerInsert) => {
        const param = {
            ...selectedRow[0],
            ...params,
            sourceApp: "main",
            enable: params.enable ? 1 : 0,
            updateUser: user.updateUser
        }
        const { retData, retMsg } = await customerService.update(param)
        globalPrompt("message", { type: "success", text: retMsg })
        return retData
    }
    const cutDisabled = async (params: ICustomerInsert, checked: boolean) => {
        const param = {
            ...selectedRow[0],
            enable: checked ? 1 : 0
        }
        const { retData, retMsg } = await customerService.update(param)
        await globalPrompt("message", { type: "success", text: "修改完成" })
        await loadData()
    }
    const onShareShop = async (params: ShareShop) => {
        const { retData, retMsg } = await customerService.shareShop(params)
        await loadData()
        return retData
    }
    const onShareUser = async (params: ShareUser) => {
        const { retData, retMsg } = await customerService.shareUser(params)
        await loadData()
        return retData
    }
    return {
        searchParam,
        dataSource,
        page,
        selectedRow,
        addParam,
        bankList,
        customerTypeList,
        shopModel,
        userModel,
        setSearchParam,
        setDataSource,
        setPage,
        setSelectedRow,
        upDataSearchParam,
        resetSearchParam,
        loadData,
        setAddParam,
        updataAddParam,
        updataEditParam,
        insertDetail,
        updataDetail,
        cutDisabled,
        setBankList,
        setCustomerTypeList,
        setShopModel,
        setUserModel,
        onShareShop,
        onShareUser,
        checkLoadData
    }
});